






































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Record from "@/models/history/record.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import i18n from "@/Plugin/i18n.ts";
import RecordHistory from "@/models/history/recordHistory.model";
import fileService from "@/services/file.service";
import BTableConfig from "../../core/BTableConfig/BTableConfig";
import Tag from "@/models/history/tag.model";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import HistoryService from "../../services/History.service";
import BaseSelectTagSearch from "@/components/base/baseSelectTag/baseSelectTagSearch.vue";
import { PermissionValue } from '@/enums/PermissionValue';
@Component({
  components: {
    BaseSelectTagSearch
  }
})
export default class HistoryTable extends GenericBTable<Record> {
  isLoading = false;
  criteria: string = "";
  colors: any = [
    {
      id: 1,
      type: "is-primary"
    },
    {
      id: 2,
      type: "is-danger"
    },
    {
      id: 3,
      type: "is-info"
    },
    {
      id: 4,
      type: "is-warning"
    },
    {
      id: 5,
      type: "is-dark"
    }
  ];
  historyRepo: HistoryService = new HistoryService();
  tagsSelected: Array<Tag> = [];
  criterio: string = null;
  rowSelected: any = null;

  setTags(data: []) {
    this.tagsSelected = data;
  }

  get getCustomType() {
    return this.colors.find(x => x.id == this.getRandomNumber).type;
  }

  remove_custom() {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar este registro?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () =>
        this.onConfirmRemove(
          this.rowSelected.id,
          this.rowSelected,
          this.rowSelected
        )
    });
  }

  protected async onConfirmRemove(id: number, data: any, props: any) {
    try {
      await this.repository.delete(id);
      this.operationSuccess("Registro eliminado!");
      if (this.tableConfig.reload) this.tableConfig.reload();
      this.rowSelected = null;
      this.$emit("remove", id, data, props);
    } catch (e) {
      this.operationFailed(e);
    }
  }

  add_custom(showFile: boolean) {
    this.$store.state.showFileInput = showFile;
    let parentId = this.$route.params.hasOwnProperty("parentId")
      ? Number(this.$route.params.parentId)
      : null;
    if (parentId && !isNaN(parentId)) {
      this.$router.push(`/historico/agregar/${parentId}`);
    } else {
      this.$router.push(`/historico/agregar/`);
    }
  }

  edit_custom(id: number) {
    let parentId = this.$route.params.hasOwnProperty("parentId")
      ? Number(this.$route.params.parentId)
      : null;
    if (parentId && !isNaN(parentId)) {
      this.$router.push(`/historico/editar/${id}/parent/${parentId}`);
    } else {
      this.$router.push(`/historico/editar/${id}`);
    }
  }

  @Watch("tagsSelected")
  async getByCode() {
    if (this.tagsSelected && this.tagsSelected.length > 0) {
      let query = this.tagsSelected.map(x => {
        return ` r/TagId eq ${x.id}`;
      });
      let params = query.join(" or");
      this.tableConfig.whereParams = `RecordTags/any(r: ${params})`;
      this.tableConfig.reload();
    } else {
      this.reloadTable();
    }
  }

  get getRandomNumber() {
    return Math.floor(Math.random() * 6) + 1;
  }

  created() {
    this.permissionValue = PermissionValue.HISTORICO;
    this.tableConfig.controller = `Record`;
    this.tableConfig.selectable = true;
    this.tableConfig.dblclick = (row: any) => {
      if (row.document == null) {
        this.verOpciones(row);
      } else {
        this.verDocument(row);
      }
    };

  }

  mounted() {
    //this.reloadTable();
    this.formatColumns();
    this.reloadTable();
  }

  async verDocument(data: any = null) {
    if (data.document.contentType == "application/octet-stream")
      await fileService.downloadOctetFile(
        data.document.id,
        data.document.originalName
      );
    else await fileService.download(data.document.id);
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.name", true);
    let tags = new BTableColumn("tags", "table.tags", true);
    name.width = "25%";
    tags.width = "45%";
    name.customTemplate = true;
    tags.customTemplate = true;
    this.tableConfig.insertColumns(name, tags);

    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }

  searchByCode(event: any) {
    if (event.keyCode === 13) {
      this.criterio = this.criterio.trim();
    }
  }

  @Watch("criterio")
  getByCriteria() {
    if (this.criterio) {
      this.tableConfig.whereParams = `contains(name, '${this.criterio}')`;
      this.tableConfig.reload();
    } else {
      this.reloadTable();
    }
  }

  @Watch("$route")
  getByParent() {
    this.reloadTable();
  }

  reloadTable() {
    this.rowSelected = null;
    let parentId = this.$route.params.hasOwnProperty("parentId")
      ? Number(this.$route.params.parentId)
      : null;
    if (parentId && !isNaN(parentId)) {
      this.tableConfig.whereParams = `parentId eq ${parentId}`;
    } else {
      this.tableConfig.whereParams = `parentId eq ${null}`;
    }
    this.tableConfig.reload();
  }

  verOpciones(row: Record) {
    let recordHistory = new RecordHistory();
    recordHistory.name = row.name;
    recordHistory.id = row.id;
    recordHistory.url = this.$route.fullPath;
    this.$store.state.recordHistory.push(recordHistory);
    this.$router.push(`/historico/padre/${row.id}`);
  }
}
